import { render, staticRenderFns } from "./CmgLeaderboardActivities.vue?vue&type=template&id=e8db588a&scoped=true&lang=pug"
import script from "./cmg-leaderboard-activities.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-activities.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardActivities.vue?vue&type=style&index=0&id=e8db588a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8db588a",
  null
  
)

export default component.exports